// extracted by css-extract-rspack-plugin
export default {"card":"_Y0cOGKSXO4HqFPJ","contained":"ASyFT2lGDE96odd3","gradient":"vuA2nA0DJ8MuNE5t","title":"RGleoFP64nfrU11n","subtitle":"Krp3m8uBM8r_E8P9"};